import { useState } from "react";
import { Link } from "react-router-dom";
import { X, Megaphone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function AnnouncementBar() {
  const { settings } = useContent();
  const [dismissed, setDismissed] = useState(false);
  const a = settings?.announcement;
  if (!a?.enabled || !a.text || dismissed) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="border-b border-forest-800/40 bg-forest px-5 py-2.5 text-center text-sm text-cream dark:bg-forest-800"
    >
      <div className="container-site flex items-center justify-center gap-3">
        <Megaphone className="h-3.5 w-3.5 shrink-0 text-terracotta-400" aria-hidden="true" />
        <p className="truncate">
          {a.text}
          {a.link_url && (
            <Link
              to={a.link_url}
              data-testid="announcement-link"
              className="ml-2 font-medium text-terracotta-400 underline-offset-4 transition-colors duration-300 hover:text-cream hover:underline"
            >
              {a.link_label || "Learn more"}
            </Link>
          )}
        </p>
        <button
          data-testid="announcement-dismiss"
          aria-label="Dismiss announcement"
          onClick={() => setDismissed(true)}
          className="ml-2 shrink-0 rounded-full p-1 transition-colors duration-300 hover:bg-cream/10"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
